import * as React from 'react';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Typography from 'components/typography/Typography';
import { Box } from '@material-ui/core';
import { infoStyles } from './Styles';
import { useTranslation, Trans } from 'react-i18next';

const CheckedInfo = ({ textTranslation, valuesTranslation, ...props }) => {
    const styles = infoStyles();
    const [t] = useTranslation();

    return (
        <Box display={'flex'} alignItems={'center'} minHeight="100%">
            <CheckCircleIcon style={{ color: '#90ED7D', marginRight: '8px' }} />

            <Typography
                variant={'RobotoRegular'}
                fontSize={16}
                textColor={'primary'}
            >
                <Trans
                    i18nKey={textTranslation}
                    components={[<b />]}
                    values={valuesTranslation}
                />
            </Typography>
        </Box>
    );
};

export default CheckedInfo;
